import { DecimalPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

import { GeneralResultEnum, NoviColumn, SimpleResult } from "FoxxyInterfaces";
import { CommonCheckService } from "FoxxyLib";




@Pipe({
  name: 'absatzPipe',
  standalone: true
})
/**
 * verschiedene Numberformats für die Absatzdaten
 *
*/
export class AbsatzPipe implements PipeTransform {

  constructor(private lipovalidate: CommonCheckService, private decimalpipe : DecimalPipe) { }

  transform(val: any, col: NoviColumn): any {
    let result = val;
    try {
    switch (col.field.toLowerCase()) {

      case 'fismenge':
      case 'mcmenge':
        return val;
      case 'fisumsatz':
        return this.decimalpipe.transform(val, '1.2-2');
      case 'mcanteil':
        return this.decimalpipe.transform(val, '1.1-1');
      default:
        //Texte und nicht definierte Werte
        result = val;
        break;
    }
    }  catch (e)
    {
      this.lipovalidate.onError?.emit(<SimpleResult>{ userMessage: 'Vorschlag darstellen', serverMessage: e.toString(), generalResult : GeneralResultEnum.OnlyDebug })
    }
    return result;
  }

}
